import { Patient } from '../../../utils/api-objects/Patient';
import { extractSubscriptionTypes } from '../utils/subscriptionTypes';

interface SubscriptionFilterProps {
  patients: Patient[] | null;
  selectedFilter: string;
  onFilterChange: (filter: string) => void;
}

export const SubscriptionFilter: React.FC<SubscriptionFilterProps> = ({
  patients,
  selectedFilter,
  onFilterChange,
}) => {
  const subscriptionTypes = extractSubscriptionTypes(patients || []);

  return (
    <div className="w-full py-3 px-4 bg-gray-50 rounded-[5px] border border-gray-200">
      <div className="flex flex-col space-y-3">
        {/* Header */}
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-gray-700">
            Filtra utenti
          </span>
        </div>
        
        {/* Filter Options */}
        <div className="flex flex-wrap gap-2">
          {/* All Users */}
          <button
            onClick={() => onFilterChange('all')}
            className={`px-3 py-1 text-xs rounded-md transition-colors duration-200 ${
              selectedFilter === 'all'
                ? 'bg-blue-100 text-blue-700 border border-blue-300 shadow-sm' 
                : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
            }`}
          >
            Tutti gli utenti
          </button>
          
          {/* All Subscription Users */}
          <button
            onClick={() => onFilterChange('subs')}
            className={`px-3 py-1 text-xs rounded-md transition-colors duration-200 ${
              selectedFilter === 'subs'
                ? 'bg-blue-100 text-blue-700 border border-blue-300 shadow-sm' 
                : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
            }`}
          >
            Solo membership
          </button>
          
          {/* Individual Subscription Types */}
          {subscriptionTypes.map((type) => (
            <button
              key={type.id}
              onClick={() => onFilterChange(type.id)}
              className={`px-3 py-1 text-xs rounded-md transition-colors duration-200 ${
                selectedFilter === type.id
                  ? 'bg-blue-100 text-blue-700 border border-blue-300 shadow-sm' 
                  : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
              }`}
            >
              {type.label}
            </button>
          ))}
        </div>
        
        {/* Active Filter Indicator */}
        {selectedFilter !== 'all' && (
          <div className="flex items-center space-x-2 pt-2 border-t border-gray-200">
            <div className="w-3 h-3 bg-blue-500 rounded-full"></div>
            <span className="text-xs text-blue-600 font-medium">
              Filtro attivo
            </span>
          </div>
        )}
      </div>
    </div>
  );
}; 